var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconParkOutlineLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56315 8.74984C8.17398 8.74984 9.47982 7.444 9.47982 5.83317C9.47982 4.22234 8.17398 2.9165 6.56315 2.9165C4.95232 2.9165 3.64648 4.22234 3.64648 5.83317C3.64648 7.444 4.95232 8.74984 6.56315 8.74984Z",
    stroke: "#100C41",
    strokeWidth: 1.64706
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64648 13.1248H9.47982V31.3539H3.64648V13.1248ZM15.3132 20.0518V31.3539H20.4173V21.1456C20.4173 19.3227 21.5111 17.8643 23.334 17.8643C25.1569 17.8643 26.2506 19.6873 26.2506 21.1456V31.3539H31.3548V20.0518C31.3548 17.8643 28.8027 13.1248 23.334 13.1248C17.8652 13.1248 15.3132 17.8643 15.3132 20.0518Z",
    stroke: "#100C41",
    strokeWidth: 1.64706,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkOutlineLinkedin);
export default __webpack_public_path__ + "static/media/icon-park-outline_linked in.ad443f6dd3c0d949eb46ac75f6a09175.svg";
export { ForwardRef as ReactComponent };